import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import type { ApiClient } from '../../api/client'
import { Readiness } from '@rp/contracts'
import { useServiceStatusClear, useServiceStatusSynced } from './useServiceStatus'

const READYZ_POLL_MS = 5_000
const READYZ_INITIAL_DELAY_MS = 300

export const ReadyzProbe = ({ api }: { api: ApiClient }) => {
  const clear = useServiceStatusClear()
  const markSynced = useServiceStatusSynced()
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const id = setTimeout(() => setEnabled(true), READYZ_INITIAL_DELAY_MS)
    return () => clearTimeout(id)
  }, [])

  const query = useQuery({
    queryKey: ['readyz-probe'],
    queryFn: async () => (await api.request(Readiness, { method: 'GET', path: '/readyz' })).data,
    refetchInterval: READYZ_POLL_MS,
    enabled,
    retry: false,
  })

  useEffect(() => {
    if (query.data === undefined) return
    clear('database_outage')
    markSynced(new Date().toISOString())
  }, [query.data, query.dataUpdatedAt, clear, markSynced])

  return null
}
